// Learn Me Lexicon tour scripts. Neutral, efficient language.
// Targets use stable #tour-* id anchors (never class names) so the spotlight
// lands on the exact element regardless of screen size or tab state.

export const LANDING_TOUR = [
  { target: "#tour-landing-search", title: "Course Creator",
    content: "Type any topic. Learn Me turns it into a narrated, chaptered course." },
  { target: "#tour-family-safe", title: "Family Safe",
    content: "Every course is filtered for respectful, all-ages content." },
  { target: "#tour-kid-mode", title: "Ages 8-12",
    content: "Switch on a simplified reading level for younger learners." },
  { target: "#tour-how-to", title: "How To",
    content: "New here? Watch a short course on using Learn Me." },
  { target: "#tour-dojo", title: "Dojo Mode",
    content: "A calm, focused space to learn, with ambient soundscapes." },
  { target: "#tour-ethics", title: "Ethics",
    content: "Our Acceptable Use policy: no data selling, no targeted advertising." },
  { target: "#tour-try-free", title: "Try it Free",
    content: "Generate your first 2-minute course — no signup needed." },
];

export const LEARNER_DASHBOARD_TOUR = [
  { target: "#tour-dash-search", title: "Course Creator",
    content: "Type any topic to start a new course." },
  { target: "#tour-dash-create", title: "One-Click Generate",
    content: "Create the course in one click — it builds on this page." },
  { target: "#tour-len-overview", title: "2-Min Overview",
    content: "The quick gist of any topic." },
  { target: "#tour-len-lunch", title: "15-Min Course",
    content: "A focused, structured lesson." },
  { target: "#tour-len-comprehensive", title: "Full Training",
    content: "Deep, module-based mastery." },
  { target: "#tour-tab-library", title: "Library",
    content: "Every course you create is saved here." },
  { target: "#tour-tab-personalpedia", title: "Personalpedia",
    content: "Scholar tool: a personal knowledge base built from your learning." },
  { target: "#tour-tab-faq", title: "Personal FAQ",
    content: "Scholar tool: pin answers to the questions you ask most." },
  { target: "#tour-tab-experts", title: "ExpertMe",
    content: "Scholar tool: learn from history's greatest minds." },
  { target: "#tour-tab-courses", title: "Expert Courses",
    content: "Scholar tool: narrated deep-dives on any expert." },
  { target: "#tour-wallet", title: "Coin Wallet",
    content: "Each course costs coins. Refill your wallet anytime." },
  { target: "#tour-go-scholar", title: "Go Scholar",
    content: "Upgrade for unlimited courses and the premium tools above." },
  { target: "#tour-dojo-toggle", title: "Dojo Mode",
    content: "Enter a calm, distraction-free space to focus." },
];

export const SCHOLAR_DASHBOARD_TOUR = [
  { target: "#tour-tab-personalpedia", title: "Personalpedia",
    content: "Your personal knowledge base, built from everything you learn." },
  { target: "#tour-tab-faq", title: "Personal FAQ",
    content: "Pin answers to the questions you ask most often." },
  { target: "#tour-tab-experts", title: "ExpertMe",
    content: "Collect and learn from history's greatest minds." },
  { target: "#tour-tab-courses", title: "Expert Courses",
    content: "Generate narrated deep-dive courses on any expert." },
];
